import ListThumbnail from './ListThumbnail';

export default ListThumbnail;
